import { createAction } from 'redux-actions';
import * as ActionTypes from './ActionTypes';

export const getRealtimeAnswer = createAction(ActionTypes.GET_REALTIME_ANSWER.REQUEST);

const initialState = {}

function realtimeAnswer(state = initialState, action) {

    switch(action.type) {
       
        case ActionTypes.GET_REALTIME_ANSWER.REQUEST: 
            return {...state}   //나중에 프로젝트 아이디 추가해야함
        case ActionTypes.GET_REALTIME_ANSWER.SUCCESS:  // 성공적으로 받았을 경우
            return action.payload.response.data
        default:
            return state;
    }
}

export default realtimeAnswer;